export default "__VITE_ASSET__DXYbkm6m__"